module.exports = __webpack_public_path__ + "img/chy_9.27e6feef.png";